import { isRejectedWithValue, Middleware } from "@reduxjs/toolkit";
import { IHttpError } from "../../shared/oversight-core/interfaces/http-errror";
import { isScopeRefusal } from "../../shared/oversight-core/utils/is-scope-refusal";
import { setPrivileges, setToken } from "../features/auth/auth-slice";
import { RootState } from "../store";

export const rtkQueryErrorLogger: Middleware = (api) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const error = action.payload as IHttpError;
    switch (error.status) {
      case 500:
        console.log(error);
        break;
      case 401:
        // A scope refusal keeps the session; any other 401 means the session is over or the
        // account was disabled. Only a signed-in caller has a session to end.
        if (
          !isScopeRefusal(error) &&
          (api.getState() as RootState).auth.token
        ) {
          localStorage.clear();
          sessionStorage.clear();
          api.dispatch(setToken(""));
          api.dispatch(setPrivileges([]));
        }
        break;
      default:
        break;
    }
  }

  return next(action);
};
